import { FENCES_CDN_PATH, FENCES_PATH } from 'landings/fences/fences-constants';
import { FencesMainPageType } from '../../fences-types';

export type FencesTypeCardStructure = {
  alt: string;
  imgSrc: string;
  title: string;
  link: {
    href: string;
    title: string;
  };
};

const PROFNASTIL = {
  alt: 'Забор из профнастила',
  imgSrc: `${FENCES_CDN_PATH}/types/profnastil.jpg/profnastil.jpg`,
  title: 'Заборы из\u00A0профнастила',
  link: {
    href: `${FENCES_PATH}zabory-iz-profnastila/`,
    title: 'Заборы из профнастила на заказ',
  },
};

const SHTAKETNIK = {
  alt: 'Металлический штакетник',
  imgSrc: `${FENCES_CDN_PATH}/types/shtaketnik.jpg/shtaketnik.jpg`,
  title: 'Металлический штакетник',
  link: {
    href: `${FENCES_PATH}metallicheskiy-shtaketnik/`,
    title: 'Металлический штакетник на заказ',
  },
};

const MODULNYE_OGRAZHDENIYA = {
  alt: 'Модульное ограждение',
  imgSrc: `${FENCES_CDN_PATH}/types/modulnye-ograzhdeniya.jpg/modulnye-ograzhdeniya.jpg`,
  title: 'Модульные ограждения',
  link: {
    href: `${FENCES_PATH}modulnye-ograzhdeniya/`,
    title: 'Модульные ограждения на заказ',
  },
};

const PANELNYE_OGRAZHDENIYA = {
  alt: 'Панельное ограждение',
  imgSrc: `${FENCES_CDN_PATH}/types/panelnye-ograzhdeniya.jpg/panelnye-ograzhdeniya.jpg`,
  title: 'Панельные ограждения',
  link: {
    href: `${FENCES_PATH}panelnye-ograzhdeniya/`,
    title: 'Панельные ограждения на заказ',
  },
};

const ZHALYUZI = {
  alt: 'Забор-жалюзи',
  imgSrc: `${FENCES_CDN_PATH}/types/zhalyuzi.jpg/zhalyuzi.jpg`,
  title: 'Заборы-жалюзи',
  link: {
    href: `${FENCES_PATH}zabory-zhalyuzi/`,
    title: 'Заборы-жалюзи на заказ',
  },
};

const FENCES_TYPES_WITHOUT_PANEL_MODUL_ZHALYUZI_LIST = [PROFNASTIL, SHTAKETNIK];

const FENCES_TYPES_WITHOUT_PANEL_MODUL_LIST = [PROFNASTIL, SHTAKETNIK, ZHALYUZI];

const FENCES_TYPES_WITH_ALL_LIST = [
  PROFNASTIL,
  SHTAKETNIK,
  MODULNYE_OGRAZHDENIYA,
  PANELNYE_OGRAZHDENIYA,
  ZHALYUZI,
];

export const FENCES_TYPES_MAP: Record<FencesMainPageType, FencesTypeCardStructure[]> = {
  withoutPanelModulZhalyuzi: FENCES_TYPES_WITHOUT_PANEL_MODUL_ZHALYUZI_LIST,
  withoutPanelModul: FENCES_TYPES_WITHOUT_PANEL_MODUL_LIST,
  withAll: FENCES_TYPES_WITH_ALL_LIST,
};
